// extracted by mini-css-extract-plugin
export default {"ctn":"waterproof_ctn__ZahiH","textBox":"waterproof_textBox__eTiZh","img":"waterproof_img__f-OLC"};